import { render } from "./ChatContent.vue?vue&type=template&id=a85f80e2&scoped=true"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=a85f80e2&scoped=true&lang=css"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85f80e2"]])

export default __exports__